import { axiosB2 } from './axiosB2';

/**
 * Duplicates a committed selection token for modal editing without mutating the source.
 * REST equivalent: entities.asmx/EntitiesSelectionCloneToken
 *
 * @param {string} sourceToken - Committed selection token (GUID)
 * @param {string} selectionFor - e.g. marketingCampaigns, campaigns, companies, contacts, opportunities
 * @returns {Promise<{ token: string, sourceToken?: string, selectionFor?: string, hadExistingSelection?: boolean }>}
 */
export function cloneSelectionToken(sourceToken, selectionFor) {
    return axiosB2
        .post('EntitiesSelectionCloneToken', { sourceToken, selectionFor })
        .then(({ data }) => {
            const response = typeof data === 'string' ? JSON.parse(data) : data;
            return response.Result;
        });
}
